// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 9.53158L12 1.19824L2 9.53158V22H7.5V13.5H16.5V22H22V9.53158Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M14.5 22H9.5V15.5H14.5V22Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-home-filled')
export default class HomeFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'home-filled',
    }
  }
}
